module.exports = __webpack_public_path__ + "static/img/index_item01.5264515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_item01.png
// module id = /4Rz
// module chunks = 0